//====================================
// Infinite Scroll
//====================================
export default class UsagiInfiniteScroll {

	constructor( prop = {} ) {

		//===
		this.prop = prop;

		//===
		this.local = prop.local ? prop.local : document;

		//===
		this.smooth = prop.smooth ? prop.smooth : false;

		//===
		this.delay = ((typeof prop.delay === 'number') && (isFinite(prop.delay))) ? prop.delay : 1000;
		this.timer = null;
		this.wait = null;

		//===
		this.ready = false;
		this.loading = false;
		this.loadall = false;

		//===
		this.fetcher = {
			controller : null,
			promise : null
		};

		//===
		const wrapName = prop.wrap ? prop.wrap : '.c-ae-wrap';
		this.wrap = {
			name : wrapName,
			el : this.local.querySelector( wrapName )
		};
		const bodyName = prop.body ? prop.body : '.c-ae-bdy';
		this.body = {
			name : bodyName,
			el : this.wrap.el.querySelector( bodyName )
		};
		const articleName = prop.article ? prop.article : 'article';
		this.article = {
			name : articleName,
			el   : this.wrap.el.querySelector( articleName )
		};
		this.next = {
			html : {
				parser : null,
				doc : null,
				wrap : null,
				article : null,
				pagger : {
					body : null
				}
			}
		}

		//===
		if( typeof prop.onLoadAfter === 'function' ) this.onLoadAfter = () => prop.onLoadAfter(this);

		//===
		this.onInit();

		//===
		// this.onLoop();

	}

	onInit(){

		//
		const paggerWrapName = this.prop.paggerWrap ? this.prop.paggerWrap : '.c-ae-pag-wrap';
		const paggerBodyName = this.prop.paggerBody ? this.prop.paggerBody : '.c-ae-pag-bdy';
		const paggerNextName = this.prop.paggerNext ? this.prop.paggerNext : '.js-get-nextpage';
		this.pagger = {
			wrap : {
				name : paggerWrapName,
				el : this.wrap.el.querySelector( paggerWrapName )
			},
			body : {
				name : paggerBodyName,
				el : this.wrap.el.querySelector( paggerBodyName )
			},
			next : {
				name : paggerNextName,
				el : this.wrap.el.querySelector( paggerNextName ),
				href : null
			},
			rect : {
				top : 0,
				left : 0,
				width : 0,
				height : 0
			}
		}

		//
		this.pagger.next.el = this.pagger.wrap.el.querySelector( this.pagger.next.name );
		if( this.pagger.next.el ){
			const link = this.pagger.next.el.querySelector('a') ? this.pagger.next.el.querySelector('a') : this.pagger.next.el;
			this.pagger.next.el.querySelector('.t').textContent = 'Loading';
			this.pagger.next.href = link.getAttribute('href');
			this.ready = true;
		} else {
			this.loadall = true;
			this.ready = false;
		}

	}

	addEvents(){
		// this.onScroll = this.onScroll.bind(this);
		// window.addEventListener('scroll', this.onScroll );
	}

	removeEvents(){
		// window.removeEventListener('scroll', this.onScroll );
	}

	onLoop() {
		// this.onScroll();
		// this.onRAF = requestAnimationFrame( this.onLoop.bind(this) );
	}

	onScroll(){
		let top = 0;
		let buffer = window.innerHeight * 2;
		if( this.ready ){
			if( this.pagger.wrap ){
				const rect = this.pagger.wrap.el.getBoundingClientRect();
				this.pagger.rect.top = rect.top - top;
			}
			if( top + buffer > this.pagger.rect.top && !this.loading && this.pagger.next.el && this.pagger.next.href && !this.loadall ){
				this.loading = true;
				this.onLoadNextPage();
			}
		}
	}

	onLoadNextPage(){

		if( !this.fetcher.controller ){

			//
			this.wrap.el.classList.add('is-loading-articles');

			//
			this.fetcher.controller = new AbortController();
			this.fetcher.promise = fetch( this.pagger.next.href, {

				signal: this.fetcher.controller.signal,
				method: "GET",
				headers: {
					'Cache-Control': 'no-cache',
					'Pragma': 'no-cache',
					'Expires': '0',
				}

			}).then( (res) => {

				if( ! res.ok ) {
					throw new Error(`Fetch: ${res.status} ${res.statusText}`);
				}
				return res.text();

			}).then(( data) => {

				this.next.html.parser = new DOMParser();
				this.next.html.doc = this.next.html.parser.parseFromString(data, "text/html");
				this.next.html.wrap = this.next.html.doc.querySelector( this.wrap.name );
				this.next.html.article = this.next.html.wrap.querySelectorAll( this.article.name );
				this.next.html.pagger.body = this.next.html.wrap.querySelector( this.pagger.body.name );
				this.onLoadEnd();

			}).catch( (error) => {

				this.onLoadError( error );

			});


		} else {

			this.fetcher.controller = null;

		}

	}

	onLoadEnd(){
	
		//
		clearTimeout( this.timer );
		this.timer = setTimeout(()=>{

			//===
			if( !this.ready ) return false;


			//===
			for (let i = 0; i < this.next.html.article.length; i++) {
				const el = this.next.html.article[i];
				this.body.el.appendChild( el );
			}

			//===
			this.pagger.wrap.el.innerHTML = '';
			this.pagger.wrap.el.appendChild( this.next.html.pagger.body );

			//===
			clearTimeout( this.wait );
			this.wait = setTimeout(()=>{

				//
				this.onInit();

				//
				if( !this.pagger.next.el ){
					this.loadall = true;
					this.wrap.el.classList.remove('is-loading-articles','is-loading-error');
					this.wrap.el.classList.add('is-ld-all-articles');
					cancelAnimationFrame( this.onRAF );
				}

				//
				this.loading = false;
				this.fetcher.controller = null;
				this.wrap.el.classList.remove('is-loading-articles');

				//
				if( this.onLoadAfter ) this.onLoadAfter();

			}, 100 );

		}, this.delay );

	}

	onLoadError( error ){
		this.wrap.el.classList.add('is-ld-all-error');
		cancelAnimationFrame( this.onRAF );
		clearTimeout( this.timer );
		clearTimeout( this.wait );
		this.loadall = false;
		this.loading = false;
		if( this.fetcher.controller ){
			this.fetcher.controller.abort();
			this.fetcher.controller = null;
			this.fetcher.promise = null;
			this.next.html.parser = null;
			this.next.html.doc = null;
		}
	}

	onDestroy(){
		cancelAnimationFrame( this.onRAF );
		clearTimeout( this.timer );
		clearTimeout( this.wait );
		this.wrap.el.classList.remove('is-loading-article','is-ld-article','is-loading-error');
		this.loadall = false;
		this.loading = false;
		if( this.fetcher.controller ){
			this.fetcher.controller.abort();
			this.fetcher.controller = null;
			this.fetcher.promise = null;
			this.next.html.parser = null;
			this.next.html.doc = null;
		}
		this.removeEvents();
	}

}